import { Component, computed, input, signal } from '@angular/core';

@Component({
  selector: 'rid-compressable-klank-card',
  imports: [],
  templateUrl: './rid-compressable-klank-card.html',
})
export class RidCompressableKlankCard {
  content = input.required<string>();

  compressed = signal<{ index: number; length: number } | undefined>(undefined);

  tw = computed(() => {
    const compressed = this.compressed();
    if (compressed) {
      const { index, length } = compressed;

      return `border-y-4 ${index === 0 ? 'ml-1 pl-4 border-l-4 rounded-bl-md rounded-tl-md' : ''} ${index === length - 1 ? 'mr-1 pr-4 border-r-4 rounded-br-md rounded-tr-md' : ''}`;
    }

    return `mx-1 border-4 p-4 rounded-md`;
  });

  public static compress(cards: RidCompressableKlankCard[]) {
    cards.forEach((card, index) => {
      card.compressed.set({ index, length: cards.length });
    });
  }

  public static decompress(cards: RidCompressableKlankCard[]) {
    cards.forEach((card) => {
      card.compressed.set(undefined);
    });
  }
}
